import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { giftCardActivation } from 'actions/EntityActions';
import { formInput } from 'actions/FormActions';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import RadioInput from 'screens/components/basic/RadioInput';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

class POSGiftCardActivation extends Component {
    constructor(props, context) {
        super(props, context);
    }

    confirmCardActivation = () => {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            Pan: p.pan,
            Expdate: p.expdate,
            CvdValue: p.cvdValue,
            InitialAmount: p.initAmount,
            OrderId: `${this.props.store.monerisStoreId}${new Date().getTime()}`,
            POSOrderId: p.activateOrderId,
            Type: this.props.type,
            TerminalId: p.terminalId,
            ProcessMethod: p.proceddMethod === true ? 1 : 0
        };
        this.props.giftCardActivation(model);
    }

    render() {
        const { t } = this.props;
        let p = this.props;
        const options = [
            {
                text: t('pos.giftCard.activation.activation'),
                value: '1'
            },
            {
                text: t('pos.giftCard.activation.reload'),
                value: '2'
            }
        ];
        return (
            <DialogInput
                title={<DialogHeaderWithClose text={t('pos.giftCard.activation.label')} classicClass="posDialogClassic" handleClose={() => this.props.onCancel()} />}
                actions={[
                    <Button
                        key={1}
                        name="buttonRefundDialogCancel"
                        type="Button"
                        className="corner_X"
                        primary={false}
                        onTouchTap={() => this.props.onCancel()} />,
                    <Button
                        key={2}
                        className="pull-right space"
                        name="buttonRefundDialogConfirm"
                        label={t('common.confirm')}
                        primary={true}
                        onTouchTap={() => this.confirmCardActivation()} />]}
                modal={true}
                style={{ zIndex: '980' }}
                open={this.props.show}
                autoScrollBodyContent={true}>
                <div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <ToggleInput className="giftCard_process_method" name={`${p.name}processMethod`} label={t('pos.giftCard.processMethod.label')} />
                    </div>
                    {
                        this.props.proceddMethod ?
                            (
                                <div>
                                    <h4>{t('pos.giftCard.activation.fillUpInfo')}</h4>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <TextInput name={`${p.name}pan`}
                                                fullWidth={true}
                                                label={t('common.cardNum')}
                                                floatingLabelText={t('common.cardNum')}
                                                hintText={t('common.cardNum')} />
                                        </div>
                                        <div className="col-lg-12">
                                            <TextInput name={`${p.name}expdate`}
                                                fullWidth={true}
                                                label={t('pos.giftCard.expdateWithFormat.label')}
                                                floatingLabelText={t('pos.giftCard.expdateWithFormat.label')}
                                                hintText={t('pos.giftCard.expdateWithFormat.hintText')} />
                                        </div>
                                        <div className="col-lg-12">
                                            <TextInput name={`${p.name}cvdValue`}
                                                fullWidth={true}
                                                label={t('pos.giftCard.cvdValue.label')}
                                                floatingLabelText={t('pos.giftCard.cvdValue.label')}
                                                hintText={t('pos.giftCard.cvdValue.hintText')} />
                                        </div>
                                        <div className="col-lg-12">
                                            <DecimalInput name={`${p.name}initAmount`}
                                                fullWidth={true}
                                                label={t('pos.giftCard.initAmount.label')}
                                                disabled={p.activateOrderId > 0}
                                                floatingLabelText={t('pos.giftCard.initAmount.label')}
                                                hintText={t('pos.giftCard.initAmount.hintText')} />
                                        </div>
                                        <div className="col-lg-12">
                                            <RadioInput
                                                groupName={`${p.name}type`}
                                                options={options}
                                                fullWidth={true}
                                            />
                                        </div>

                                    </div>
                                </div>
                            )
                            :
                            (
                                <div>
                                    <h5>{t('pos.giftCard.readyToSwipeCard.text')}</h5>
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}cvdValue`}
                                            fullWidth={true}
                                            label={t('pos.giftCard.cvdValue.label')}
                                            floatingLabelText={t('pos.giftCard.cvdValue.label')}
                                            hintText={t('pos.giftCard.cvdValue.hintText')} />
                                    </div>
                                    <div>
                                        <div className="col-lg-12">
                                            <DecimalInput name={`${p.name}initAmount`}
                                                fullWidth={true}
                                                label={t('pos.giftCard.initAmount.label')}
                                                disabled={p.activateOrderId > 0}
                                                floatingLabelText={t('pos.giftCard.initAmount.label')}
                                                hintText={t('pos.giftCard.initAmount.hintText')}
                                            />
                                        </div>
                                        <div className="col-lg-12">
                                            <RadioInput
                                                groupName={`${p.name}type`}
                                                options={options}
                                                fullWidth={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                    }

                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        pan: state.form[`POSGiftCardActivationpan`] || '',
        expdate: state.form[`POSGiftCardActivationexpdate`] || '',
        cvdValue: state.form[`POSGiftCardActivationcvdValue`] || '',
        initAmount: state.form[`POSGiftCardActivationinitAmount`] || "0.00",
        type: state.form[`POSGiftCardActivationtype`] || '',
        store: state.common.store,
        proceddMethod: state.form[`POSGiftCardActivationprocessMethod`],
        terminalId: state.entity.cashFlow ? state.entity.cashFlow.terminalId : ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        giftCardActivation: (model) => dispatch(giftCardActivation(model)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSGiftCardActivation));